import React, { useState } from "react";
import { connect } from "react-redux";
import { applySpec } from "ramda";
import { mediaItemFieldChanged } from "edit-media/redux/editMediaActions";
import { getEditMediaItemDescriptionText } from "common/selectors";
// import { firstError } from "util/validation";
import { getEditMediaErrors } from "common/selectors";
import RichTextEditor from "react-rte";

const stripHtmlElements = html => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const EditMediaDescriptionTab = ({
  descriptionText,
  errors,
  onFieldChange,
}) => {
  const [internalDescription, setInternalDescription] = useState(
    RichTextEditor.createValueFromString(descriptionText || "", "html"),
  );

  return (
    <div>
      <RichTextEditor
        label="Description"
        value={internalDescription}
        onChange={value => {
          setInternalDescription(value);

          const htmlValue = value.toString("html");
          onFieldChange(["descriptionText"])(htmlValue);
          onFieldChange(["description"])(stripHtmlElements(htmlValue));
        }}
      />
    </div>
  );
};

const mapStateToProps = applySpec({
  descriptionText: getEditMediaItemDescriptionText,
  errors: getEditMediaErrors,
});

const mapDispatchToProps = dispatch => ({
  onFieldChange: path => value => dispatch(mediaItemFieldChanged(path, value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditMediaDescriptionTab);
